/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1SsoimageIdMutationRequest,
  PutApiV1SsoimageIdMutationResponse,
  PutApiV1SsoimageIdPathParams,
  PutApiV1SsoimageId400,
  PutApiV1SsoimageId401,
  PutApiV1SsoimageId500,
} from "../../types/SSOImageController/PutApiV1SsoimageId.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPutApiV1SsoimageIdUrl(id: PutApiV1SsoimageIdPathParams["id"]) {
  const res = { method: "PUT", url: `/api/v1/ssoimage/${id}` as const };
  return res;
}

/**
 * @description Atualiza os dados de uma SSOImage, incluindo título, categoria, datas e idiomas. Para cada idioma informado, o arquivo .json é enviado ao Azure Blob Storage e o URL de armazenamento é atualizado. Idiomas com Id informado são atualizados; idiomas sem Id são criados como novos registros. **(Requer Authorization para autenticação)**
 * @summary Atualizar imagem SSO (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/:id}
 */
export async function putApiV1SsoimageId(
  id: PutApiV1SsoimageIdPathParams["id"],
  data: PutApiV1SsoimageIdMutationRequest,
  config: Partial<RequestConfig<PutApiV1SsoimageIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PutApiV1SsoimageIdMutationResponse,
    ResponseErrorConfig<
      PutApiV1SsoimageId400 | PutApiV1SsoimageId401 | PutApiV1SsoimageId500
    >,
    PutApiV1SsoimageIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1SsoimageIdUrl(id).url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
